"use strict";

var _utils = require("./utils");

module.exports = function (element) {
    var _this = this;

    var blocks = 0;

    for (var i = 0; i < this.options.elements.length; i++) {
        if (element.querySelector(this.options.elements[i]) == null) {
            console.warn("Element " + this.options.elements[i] + " is not in current page.");
        } else {
            (0, _utils.queryAll)(this.options.elements[i]).forEach(function (item, index) {
                (0, _utils.queryAll)(_this.options.elements[i], element)[index].dataset.swup = blocks;
                blocks++;
            });
        }
    }
};


// WEBPACK FOOTER //
// ./node_modules/swup/lib/modules/markSwupElements.js